<template>
  <!-- todo : variant class depends on props -->
  <div :class="classes">
    <div v-if="title" class="banner">{{ title | uppercase }}</div>
    <div :class="unpadded ? 'content' : 'content padded'">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VvBox',
  props: {
    title: String,
    unpadded: Boolean,
    clickable: Boolean,
    gradient: Boolean,
    shadow: Boolean
  },
  filters: {
    uppercase(value) {
      return value.toUpperCase()
    }
  },
  computed: {
    classes() {
      const classes = ['vv-box']

      if (this.clickable) classes.push('clickable')

      if (this.gradient) classes.push('gradient')

      if (this.shadow) classes.push('shadow')

      return classes
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

// the speech bubble is a completely different component even if it looks the same
.vv-box {
  border-radius: 0.4em;
  overflow: hidden;
  box-shadow: 0 14px 28px 5px rgba(220, 220, 220, 0.5);
  margin-bottom: 10px;
  transition: box-shadow 200ms linear;
  background: #ffffff;

  &:hover {
    box-shadow: 0 14px 28px 5px rgba(220, 220, 220, 0.75);
  }

  &.clickable {
    cursor: pointer;
  }

  &.gradient {
    background-image: linear-gradient(258deg, $tertiary, $primary);
    color: #ffffff;
  }

  &.shadow {
    box-shadow: 0 3px 6px #00000029;
  }

  .banner {
    padding: 6px 30px;
    font-size: 10.8px;
    font-weight: 900;
    text-align: left;
    background-image: linear-gradient(258deg, $tertiary, $primary);
    color: #ffffff;
  }

  .content {
    // padding: 20px 25px;
    font-size: 14px;
    font-weight: 900;
  }

  .padded {
    padding: 20px 20px 30px;
  }
}
</style>
